export const states = [
  { value: "AL", label: "Alabama" },
  { value: "AK", label: "Alaska" },
  { value: "AZ", label: "Arizona" },
  { value: "AR", label: "Arkansas" },
  { value: "CA", label: "California" },
  { value: "CO", label: "Colorado" },
  { value: "CT", label: "Connecticut" },
  { value: "DE", label: "Delaware" },
  { value: "FL", label: "Florida" },
  { value: "GA", label: "Georgia" },
  { value: "HI", label: "Hawaii" },
  { value: "ID", label: "Idaho" },
  { value: "IL", label: "Illinois" },
  { value: "IN", label: "Indiana" },
  { value: "IA", label: "Iowa" },
  { value: "KS", label: "Kansas" },
  { value: "KY", label: "Kentucky" },
  { value: "LA", label: "Louisiana" },
  { value: "ME", label: "Maine" },
  { value: "MD", label: "Maryland" },
  { value: "MA", label: "Massachusetts" },
  { value: "MI", label: "Michigan" },
  { value: "MN", label: "Minnesota" },
  { value: "MS", label: "Mississippi" },
  { value: "MO", label: "Missouri" },
  { value: "MT", label: "Montana" },
  { value: "NE", label: "Nebraska" },
  { value: "NV", label: "Nevada" },
  { value: "NH", label: "New Hampshire" },
  { value: "NJ", label: "New Jersey" },
  { value: "NM", label: "New Mexico" },
  { value: "NY", label: "New York" },
  { value: "NC", label: "North Carolina" },
  { value: "ND", label: "North Dakota" },
  { value: "OH", label: "Ohio" },
  { value: "OK", label: "Oklahoma" },
  { value: "OR", label: "Oregon" },
  { value: "PA", label: "Pennsylvania" },
  { value: "RI", label: "Rhode Island" },
  { value: "SC", label: "South Carolina" },
  { value: "SD", label: "South Dakota" },
  { value: "TN", label: "Tennessee" },
  { value: "TX", label: "Texas" },
  { value: "UT", label: "Utah" },
  { value: "VT", label: "Vermont" },
  { value: "VA", label: "Virginia" },
  { value: "WA", label: "Washington" },
  { value: "WV", label: "West Virginia" },
  { value: "WI", label: "Wisconsin" },
  { value: "WY", label: "Wyoming" },
];

export const businessEntities = [
  { value: "sole_proprietor", label: "Sole Proprietor" },
  { value: "association_unincorporated", label: "Association - Unincorporated" },
  { value: "trust", label: "Trust" },
  { value: "corporation_public", label: "Corporation - Public" },
  { value: "corporation_private", label: "Corporation - Private" },
  { value: "llc", label: "LLC" },
  { value: "partnership", label: "Partnership" },
  { value: "non_profit_unincorporated", label: "Non-Profit - Unincorporated" },
  { value: "non_profit_incorporated", label: "Non-Profit - Incorporated" },
];

export const companySizeOptions = [
  { value: "self_employed", label: "1 (Self Employed)" },
  { value: "2_10", label: "2-10" },
  { value: "11_100", label: "11-100" },
  { value: "101_1000", label: "101-1,000" },
  { value: "1001_1500", label: "1,001-1,500" },
  { value: "1500+", label: "1,500+" },
];

export const loanTypeOptions = [
  { value: 'SBA 7(a)', label: 'SBA 7(a)' },
  { value: 'SBA 504', label: 'SBA 504' },
  { value: 'Microloan', label: 'Microloan' },
  { value: 'Term Loan', label: 'Term Loan' },
  { value: 'Line of Credit', label: 'Line of Credit' },
  { value: 'Equipment Financing', label: 'Equipment Financing' },
  { value: 'Commercial Real Estate', label: 'Commercial Real Estate' },
  { value: 'Merchant Cash Advance', label: 'Merchant Cash Advance' },
  { value: 'Invoice Factoring', label: 'Invoice Factoring' },
  { value: 'Invoice Financing', label: 'Invoice Financing' },
  { value: 'Business Acquisition', label: 'Business Acquisition' },
  { value: 'Working Capital', label: 'Working Capital' },
  { value: 'Farm Operating Loan', label: 'Farm Operating Loan' },
  { value: 'Farmland Purchase', label: 'Farmland Purchase' },
  { value: 'Ag Equipment Financing', label: 'Ag Equipment Financing' },
  { value: 'Other', label: 'Other' },
];

export const loanUseOptions = [
  { value: 'Working Capital / Cash Flow', label: 'Working Capital / Cash Flow' },
  { value: 'Equipment Purchase', label: 'Equipment Purchase' },
  { value: 'Expansion', label: 'Expansion' },
  { value: 'Inventory', label: 'Inventory' },
  { value: 'Payroll', label: 'Payroll' },
  { value: 'Other', label: 'Other' },
];

export const personalCreditScoreOptions = [
  { value: 'Excellent (720+)', label: 'Excellent (720+)' },
  { value: 'Good (680-719)', label: 'Good (680-719)' },
  { value: 'Fair (640-679)', label: 'Fair (640-679)' },
  { value: 'Poor (639 or less)', label: 'Poor (639 or less)' },
];